import {useState} from 'react';
import {Box, Button, Grid, Group, TextInput} from '@mantine/core';
import {useForm} from '@mantine/form';
import {ArrowRight} from "tabler-icons-react";
import { ISupplier } from "features/suppliers"

interface Props {
    onSubmitQuery?: (query: any) => void,
    initialValues?: any
}

export function SupplierCreateForm({onSubmitQuery, initialValues}: Props) {
    const [creatingSupplier, setCreatingSupplier] = useState(false);
    const form = useForm<ISupplier>({
        initialValues: initialValues || {},
        validate: {},
    });


    async function onSubmit(values: typeof form.values) {
        if (onSubmitQuery) {
            setCreatingSupplier(true);
            await onSubmitQuery(values)
            setCreatingSupplier(false);
        }
    }


    return (
        <Box mx="auto">
            <form onSubmit={form.onSubmit(onSubmit)}>
                <Grid>
                    <Grid.Col sm={12}>
                        <TextInput label="Name" {...form.getInputProps('name')}/>
                    </Grid.Col>
                    <Grid.Col sm={12}>
                        <Group position="right" mt="md">
                            <Button type="submit" loading={ creatingSupplier }
                                    rightIcon={<ArrowRight/>}>
                                Add New Supplier
                            </Button>
                        </Group>
                    </Grid.Col>
                </Grid>
            </form>
        </Box>
    )
}
